import userStoreModule from './user'

export const useUserStore = userStoreModule
